module.exports = __webpack_public_path__ + "static/media/8OLA27.604fd8e6.jpg";